import script from "./DefaultGroupsLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultGroupsLoader.vue?vue&type=script&setup=true&lang=js"

import "./DefaultGroupsLoader.vue?vue&type=style&index=0&id=1faf376c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1faf376c"]])

export default __exports__